<template>
<div>
      <template>
        <v-btn
          @click.stop = "dialog=true"
          color=""
          class="mygreen"
          dark
          >

            <img class="img" src="/img/icon_search.svg" style="margin-left: -6px;margin-right:6px;width:22px;" />
          <span>休暇申請検索</span></v-btn>
      </template>

    <v-dialog
      v-model="dialog"
      max-width="600px"
    >

      <v-card class="rounded-lg">
        <v-toolbar
          class="mb-9 text-center"
          color="mygreen"
          dark><span class="text-center">休暇検索</span></v-toolbar>
        <v-card-text>
          <v-container>
            <v-row>


              <v-col class="text-left" cols="3">スタッフ名</v-col>
              <v-col cols="9" >
                  <v-select
                        v-model="data.staff_selected"
                        :items="arr_staff"
                        item-text="name"
                        item-value="id"
                        menu-props="auto"
                        outlined
                      placeholder="選択してください"
                  ></v-select>
              </v-col>



              <v-col class="text-left" cols="3">取得希望日</v-col>
              <v-col cols="9" >
                  <v-row>
                      <v-col cols="5.5" >
                        <v-menu
                            v-model="menu_from"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="auto">
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                @keyup.enter="search()"
                                v-model="data.from"
                                append-icon="mdi-calendar-month"
                                outlined
                                v-bind="attrs"
                                v-on="on"></v-text-field>
                            </template>
                            <v-date-picker
                            v-model="data.from"
                            @input="menu_from = false"
                            color="mygreen"
                            :no-title="true"
                            locale="jp-ja"
                            :day-format="date => new Date(date).getDate()"
                            ></v-date-picker>
                        </v-menu>
                      </v-col>
                      <v-col cols="1" >～</v-col>
                      <v-col cols="5.5" >

                        <v-menu
                            v-model="menu_to"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="auto">
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                @keyup.enter="search()"
                                v-model="data.to"
                                append-icon="mdi-calendar-month"
                                outlined
                                v-bind="attrs"
                                v-on="on"></v-text-field>
                            </template>
                            <v-date-picker 
                            v-model="data.to" 
                            @input="menu_to = false"
                            color="mygreen"
                            :no-title="true"
                            locale="jp-ja"
                            :day-format="date => new Date(date).getDate()"
                            ></v-date-picker>
                        </v-menu>
                      </v-col>
                  </v-row>
              </v-col>



              <v-col class="text-left" cols="3">休暇種別</v-col>
              <v-col cols="9" class="pt-0" style="height:58px;">
                <v-select outlined
                    :items="syubetu"
                    v-model="data.syubetu_selected"
                    label=""></v-select>
              </v-col>

              <v-col class="text-left" cols="3">ステータス</v-col>
              <v-col cols="9" class="pt-0">
                    <v-checkbox
                      v-model="data.status"
                      label="承認待ち"
                      value="承認待ち"
                      color="#8CC11E"
                    ></v-checkbox>
                    <v-checkbox
                      v-model="data.status"
                      label="差し戻し"
                      value="差し戻し"
                      color="#8CC11E"
                    ></v-checkbox>
                    <v-checkbox
                      v-model="data.status"
                      label="承認"
                      value="承認"
                      color="#8CC11E"
                    ></v-checkbox>
              </v-col>
            </v-row>

          </v-container>
        </v-card-text>

        <v-card-actions class="pb-6">
          <v-spacer></v-spacer>
          <v-btn
            color="white"
            @click="clear()">条件クリア</v-btn>
          <v-btn
            color="white"
            @click="dialog = false">戻る</v-btn>
          <v-btn dark
            color="mygreen"
            @click="search()">検索</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</div>
</template>


<script>
// @ is an alias to /src
/* eslint-disable */
import mycolor from '@/mycolor.js';
import axios from 'axios';
/* eslint-disable */



export default {

    props: {
      dialogFlag: Boolean,
      arr_staff: Array,
      isSameroute: Boolean,
    },
    created () {
        console.log('%c created: DialogKyukaSearch.vue', mycolor.created);
    },


    // datas
    data() {
            return {
                syubetu: ['全休', '午前休', '午後休'],

                dialog: false,
                menu_from: '',
                menu_to: '',
                data:{
                    from: '',
                    to: '',
                    status: [ ],
                    syubetu_selected: '',
                    staff_selected: '',
                }
            }
    },
    /* eslint-disable */
    methods: {
        clear(){
            console.group();
            console.log('%c %s', mycolor.strong, 'clear()');
            console.log('this.data:', this.data);
            this.data = {
                    from: '',
                    to: '',
                    status: [ ],
                    syubetu_selected: '',
                    staff_selected: '',
                }
            console.groupEnd();
        },
        search(){
            console.group();
            console.log('%csearch()', mycolor.purple);
            console.log('this.data:', this.data);
            console.groupEnd();

            this.$emit("search", this.data);

            this.dialog = false;

        }  // search()

    }, // methods
    /* eslint-disable */
}
</script>

<style scoped>
/deep/ .v-input__append-inner{
    margin: auto !important;
}
/deep/ .row > div {
/*    height: 70px; */
}
/deep/ .v-list-item__content{
    text-align: left;
}
/deep/ .theme--light.v-input{
    margin-top: -8px;
}
/deep/ .v-select__slot{
    height: 40px;
}
/deep/ .v-dialog > .v-card > .v-card__text{
    padding-bottom: 0px;
}
</style>
